var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-robot-box"},[_c('div',{staticClass:"loading"},[_vm._v(" 思索中，请稍等片刻 "),_c('div',{staticClass:"loading-circle circle_1"}),_c('div',{staticClass:"loading-circle circle_2"}),_c('div',{staticClass:"loading-circle circle_3"})])])
}]

export { render, staticRenderFns }